import { CountryCode } from "../utils/enum";
import useLayoutData from "./useLayoutData";

const useBelgium = () => {
  const { country, isPending } = useLayoutData();

  return {
    isBelgium: country === CountryCode.BELGIUM,
    isPending,
  };
};

export default useBelgium;
